import { useState, useEffect } from "react"
import { getProfile } from "~/api/auth"
import type { ProfileResponse } from "~/api/auth"

export function useProfile() {
  const [profile, setProfile] = useState<ProfileResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const refetch = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await getProfile()
      setProfile(data)
      return data
    } catch (e) {
      setError(e as Error)
      throw e
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    refetch().catch(() => {})
  }, [])

  return { profile, loading, error, refetch }
}
